/* OmanHikes theme — interactions */
(function(){
  "use strict";

  var isEnglish=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;

  /* Keep English storefront navigation inside /en, including links emitted by apps. */
  function localizeInternalLinks(root){
    if(!isEnglish) return;
    (root||document).querySelectorAll('a[href^="/"]').forEach(function(link){
      var href=link.getAttribute('href')||'';
      if(!href || href.indexOf('//')===0 || /^\/en(?:\/|\?|#|$)/.test(href)) return;
      if(/^\/(?:cdn|admin|checkouts|payments|localization)(?:\/|\?|#|$)/.test(href)) return;
      link.setAttribute('href','/en'+href);
    });
  }
  localizeInternalLinks(document);

  /* Localise text returned by the adventurer-profile app proxy. */
  var englishProxyCopy={
    'ملف المغامر':'Adventurer profile',
    'رحلتك تبدأ من هنا':'Your journey starts here',
    'ادخل بإيميلك، تابع رحلاتك، نقاطك، وجاهزية ملفك.':'Sign in with your email to follow your trips, rewards, and profile readiness.',
    'مزايا ملف المغامر':'Adventurer profile benefits',
    'رحلاتك':'Your trips',
    'نقاطك':'Your rewards',
    'جاهزية ملفك':'Profile readiness',
    'الدخول إلى ملف المغامر':'Sign in to your adventurer profile',
    'اكتب إيميلك هنا، ثم سننقلك لخطوة رمز الدخول الآمنة من Shopify. بعد الدخول ترجع إلى ملف المغامر.':'Enter your email and we’ll take you to Shopify’s secure sign-in code. Once verified, you’ll return to your adventurer profile.',
    'الإيميل':'Email',
    'متابعة برمز الدخول':'Continue with a sign-in code',
    'الدخول مباشرة عبر Shopify':'Continue directly with Shopify',
    'نستخدم تسجيل الدخول الأصلي من Shopify لحماية حسابك وطلباتك.':'We use Shopify’s secure sign-in to protect your account and bookings.'
  };
  var arabicProxyCopy={
    'ادخل بإيميلك، تابع رحلاتك، نقاطك، وجاهزية ملفك.':'أدخل بريدك الإلكتروني لمتابعة رحلاتك ومكافآتك وجاهزية ملفك.',
    'نقاطك':'مكافآتك',
    'اكتب إيميلك هنا، ثم سننقلك لخطوة رمز الدخول الآمنة من Shopify. بعد الدخول ترجع إلى ملف المغامر.':'أدخل بريدك الإلكتروني، وسنرسل لك رمز دخول آمناً. بعد التحقق ستعود مباشرة إلى ملف المغامر.',
    'الإيميل':'البريد الإلكتروني',
    'متابعة برمز الدخول':'المتابعة برمز الدخول',
    'الدخول مباشرة عبر Shopify':'المتابعة إلى تسجيل الدخول الآمن',
    'نستخدم تسجيل الدخول الأصلي من Shopify لحماية حسابك وطلباتك.':'نستخدم تسجيل دخول آمناً لحماية حسابك وحجوزاتك.'
  };
  function localizeProxyCopy(root){
    var proxyCopy=isEnglish?englishProxyCopy:arabicProxyCopy;
    var scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('main *').forEach(function(el){
      Array.prototype.forEach.call(el.childNodes,function(node){
        if(node.nodeType!==3) return;
        var original=node.nodeValue||'', key=original.trim();
        if(proxyCopy[key]) node.nodeValue=original.replace(key,proxyCopy[key]);
      });
      ['aria-label','title'].forEach(function(attr){
        var value=el.getAttribute&&el.getAttribute(attr);
        if(value&&proxyCopy[value.trim()]) el.setAttribute(attr,proxyCopy[value.trim()]);
      });
    });
    if(isEnglish){
      scope.querySelectorAll('main a[href*="locale=ar"]').forEach(function(link){
        link.setAttribute('href',(link.getAttribute('href')||'').replace(/([?&])locale=ar(?:&|$)/,'$1locale=en&').replace(/[?&]$/,''));
      });
    }
  }
  function localizeFitnessSummary(){
    if(!isEnglish) return;
    var levels={'مبتدئ':'Beginner','متوسط':'Intermediate','متقدم':'Advanced'};
    document.querySelectorAll('#ohTravelSummary .oh-summary__item').forEach(function(row){
      var label=row.querySelector('span'),value=row.querySelector('b');
      if(label && label.textContent==='Fitness level' && value && levels[value.textContent.trim()]) value.textContent=levels[value.textContent.trim()];
    });
  }
  localizeProxyCopy(document);
  localizeFitnessSummary();
  if(window.MutationObserver){
    new MutationObserver(function(){localizeProxyCopy(document);localizeFitnessSummary();}).observe(document.body,{childList:true,subtree:true});
  }

  var header=document.querySelector('.site-header'),headerScrolled=false;
  function onScroll(){
    if(!header) return;
    var next=headerScrolled ? window.scrollY>16 : window.scrollY>56;
    if(next===headerScrolled) return;
    headerScrolled=next;
    header.classList.toggle('scrolled',next);
  }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  /* mobile drawer */
  var burger=document.querySelector('.burger'),
      drawer=document.querySelector('.drawer'),
      dclose=document.querySelector('.drawer-close');
  function openD(){ if(drawer){drawer.classList.add('open');document.body.style.overflow='hidden';} }
  function closeD(){ if(drawer){drawer.classList.remove('open');document.body.style.overflow='';} }
  if(burger) burger.addEventListener('click',openD);
  if(dclose) dclose.addEventListener('click',closeD);
  if(drawer) drawer.querySelectorAll('a').forEach(function(a){a.addEventListener('click',closeD);});

  /* keep Arabic UI text, but force English numerals everywhere visible */
  var digitMap={'٠':'0','١':'1','٢':'2','٣':'3','٤':'4','٥':'5','٦':'6','٧':'7','٨':'8','٩':'9','۰':'0','۱':'1','۲':'2','۳':'3','۴':'4','۵':'5','۶':'6','۷':'7','۸':'8','۹':'9','٬':',','٫':'.'};
  function toEnglishDigits(text){ return String(text).replace(/[٠-٩۰-۹٬٫]/g,function(ch){return digitMap[ch]||ch;}); }
  function normalizeTextDigits(root){
    var walker=document.createTreeWalker(root||document.body,NodeFilter.SHOW_TEXT,{
      acceptNode:function(node){
        var p=node.parentElement;
        if(!p || /^(SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION)$/.test(p.tagName)) return NodeFilter.FILTER_REJECT;
        return /[٠-٩۰-۹٬٫]/.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var n;
    while((n=walker.nextNode())) n.nodeValue=toEnglishDigits(n.nodeValue);
  }
  normalizeTextDigits(document.body);

  /* reveal */
  var prefersReduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals=document.querySelectorAll('.reveal');
  if(prefersReduced || !('IntersectionObserver' in window)){
    reveals.forEach(function(el){el.classList.add('in');});
  }else{
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
    },{threshold:.08,rootMargin:'0px 0px -20px 0px'});
    reveals.forEach(function(el){io.observe(el);});
  }

  /* count-up */
  var numberLocale='en-US';
  function formatNumber(value){ return value.toLocaleString(numberLocale); }
  function countUp(el){
    var target=parseFloat(el.dataset.count),dur=1100,t0=null;
    if(prefersReduced){el.textContent=formatNumber(target);return;}
    function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1);
      el.textContent=formatNumber(Math.floor(target*(1-Math.pow(1-p,3))));
      if(p<1) requestAnimationFrame(step); else el.textContent=formatNumber(target);
    } requestAnimationFrame(step);
  }
  var nio=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ countUp(e.target); nio.unobserve(e.target);} });
  },{threshold:.5});
  document.querySelectorAll('[data-count]').forEach(function(el){nio.observe(el);});

  /* upcoming trips rail */
  function getRtlMode(el){
    var original=el.scrollLeft;
    el.scrollLeft=1;
    var mode=el.scrollLeft===0?'negative':'positive';
    el.scrollLeft=original;
    return mode;
  }
  function setRailProgress(el, progress, rtlMode){
    var max=Math.max(0, el.scrollWidth-el.clientWidth);
    if(!max) return;
    progress=Math.max(0,Math.min(1,progress));
    var target=max*progress;
    if(document.documentElement.dir==='rtl' || el.dir==='rtl'){
      el.scrollLeft=rtlMode==='negative' ? -target : target;
    }else{
      el.scrollLeft=target;
    }
  }
  function getRailProgress(el, rtlMode){
    var max=Math.max(0, el.scrollWidth-el.clientWidth);
    if(!max) return 1;
    var current=el.scrollLeft;
    if(document.documentElement.dir==='rtl' || el.dir==='rtl'){
      current=rtlMode==='negative' ? Math.abs(current) : current;
    }
    return Math.max(0,Math.min(1,current/max));
  }
  function syncProgress(el, rtlMode){
    var bar=el.parentElement && el.parentElement.querySelector('.mobile-rail-progress span');
    if(!bar) return;
    var progress=getRailProgress(el,rtlMode);
    bar.style.transform='scaleX('+(.18+(progress*.82))+')';
  }
  function initSliderNav(slider, rtlMode){
    var wrap = slider.parentElement;
    if (!wrap) return;
    var progress = wrap.querySelector('.mobile-rail-progress');
    if (!progress) return;

    var navWrap = document.createElement('div');
    navWrap.className = 'slider-nav-wrap';

    var btnGroup = document.createElement('div');
    btnGroup.className = 'slider-nav-buttons';

    var btnPrev = document.createElement('button');
    btnPrev.className = 'slider-nav-btn prev';

    var btnNext = document.createElement('button');
    btnNext.className = 'slider-nav-btn next';

    var isRtl = document.documentElement.dir === 'rtl' || slider.dir === 'rtl';
    btnPrev.setAttribute('aria-label', isRtl ? 'السابق' : 'Previous');
    btnNext.setAttribute('aria-label', isRtl ? 'التالي' : 'Next');
    if (isRtl) {
      btnPrev.innerHTML = '<svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btnNext.innerHTML = '<svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    } else {
      btnPrev.innerHTML = '<svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btnNext.innerHTML = '<svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    btnGroup.appendChild(btnPrev);
    btnGroup.appendChild(btnNext);

    progress.parentNode.insertBefore(navWrap, progress);
    navWrap.appendChild(progress);
    navWrap.appendChild(btnGroup);

    function updateButtonStates() {
      var progress = getRailProgress(slider, rtlMode);
      var isStart = progress <= 0.03;
      var isEnd = progress >= 0.97;

      btnPrev.disabled = isStart;
      if (isStart) btnPrev.classList.add('disabled');
      else btnPrev.classList.remove('disabled');

      btnNext.disabled = isEnd;
      if (isEnd) btnNext.classList.add('disabled');
      else btnNext.classList.remove('disabled');
    }

    slider.addEventListener('scroll', updateButtonStates, {passive:true});
    window.addEventListener('resize', updateButtonStates);
    setTimeout(updateButtonStates, 100);

    btnNext.addEventListener('click', function(){
      var card = slider.querySelector('.trip-card, .dest, .pillar-card, .safety-item, .step, .testi-card');
      if(!card) return;
      var cardWidth = card.clientWidth + 16;
      var scrollDirection = isRtl
        ? (rtlMode === 'negative' ? -cardWidth : cardWidth)
        : cardWidth;
      slider.scrollBy({ left: scrollDirection, behavior: prefersReduced ? 'auto' : 'smooth' });
    });

    btnPrev.addEventListener('click', function(){
      var card = slider.querySelector('.trip-card, .dest, .pillar-card, .safety-item, .step, .testi-card');
      if(!card) return;
      var cardWidth = card.clientWidth + 16;
      var scrollDirection = isRtl
        ? (rtlMode === 'negative' ? cardWidth : -cardWidth)
        : -cardWidth;
      slider.scrollBy({ left: scrollDirection, behavior: prefersReduced ? 'auto' : 'smooth' });
    });
  }

  document.querySelectorAll('[data-trips-slider]').forEach(function(slider){
    var isDown=false,startX=0,startScroll=0,raf=null;
    var rtlMode=getRtlMode(slider);
    function sync(){
      if(raf) return;
      raf=requestAnimationFrame(function(){ raf=null; syncProgress(slider,rtlMode); });
    }
    slider.addEventListener('pointerdown',function(e){
      if(e.pointerType && e.pointerType !== 'mouse') return;
      if(e.button !== undefined && e.button !== 0) return;
      isDown=true; startX=e.clientX; startScroll=slider.scrollLeft; slider.classList.add('is-dragging');
    });
    window.addEventListener('pointerup',function(){ isDown=false; slider.classList.remove('is-dragging'); });
    window.addEventListener('pointercancel',function(){ isDown=false; slider.classList.remove('is-dragging'); });
    slider.addEventListener('pointermove',function(e){
      if(!isDown) return;
      e.preventDefault();
      var delta=e.clientX-startX;
      if(document.documentElement.dir==='rtl' || slider.dir==='rtl'){
        slider.scrollLeft=rtlMode==='negative' ? startScroll+delta : startScroll-delta;
      }else{
        slider.scrollLeft=startScroll-delta;
      }
      sync();
    });
    slider.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();
    initSliderNav(slider, rtlMode);
  });

  /* mobile RTL rails: destinations, testimonials, booking steps */
  document.querySelectorAll('[data-mobile-slider]').forEach(function(slider){
    var isDown=false,startX=0,startScroll=0,raf=null;
    var rtlMode=getRtlMode(slider);
    function sync(){
      if(raf) return;
      raf=requestAnimationFrame(function(){ raf=null; syncProgress(slider,rtlMode); });
    }
    slider.addEventListener('pointerdown',function(e){
      if(e.pointerType && e.pointerType !== 'mouse') return;
      if(e.button !== undefined && e.button !== 0) return;
      isDown=true; startX=e.clientX; startScroll=slider.scrollLeft; slider.classList.add('is-dragging');
    });
    window.addEventListener('pointerup',function(){ isDown=false; slider.classList.remove('is-dragging'); });
    window.addEventListener('pointercancel',function(){ isDown=false; slider.classList.remove('is-dragging'); });
    slider.addEventListener('pointermove',function(e){
      if(!isDown) return;
      e.preventDefault();
      var delta=e.clientX-startX;
      if(document.documentElement.dir==='rtl' || slider.dir==='rtl'){
        slider.scrollLeft=rtlMode==='negative' ? startScroll+delta : startScroll-delta;
      }else{
        slider.scrollLeft=startScroll-delta;
      }
      sync();
    });
    slider.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();
    initSliderNav(slider, rtlMode);
  });

  /* accordions */
  function bindAcc(qSel,itemSel,bodySel){
    document.querySelectorAll(qSel).forEach(function(btn){
      btn.addEventListener('click',function(){
        var item=btn.closest(itemSel),body=item.querySelector(bodySel),open=item.classList.contains('open');
        item.classList.toggle('open');
        body.style.maxHeight = open ? null : body.scrollHeight+'px';
      });
    });
  }
  bindAcc('.acc__q','.acc','.acc__a');
  bindAcc('.it-day__head','.it-day','.it-day__body');

  /* booking modal: product form stays intact, while the customer sees a clear stepper */
  var modal=document.querySelector('[data-booking-modal]'),
      form=document.querySelector('[data-booking-form]'),
      bookBtn=document.getElementById('bookBtn'),
      risk=document.getElementById('riskCheck'),
      riskProp=document.getElementById('riskProp'),
      amountConfirm=document.getElementById('amountConfirm');

  function omrSvg(){
    return '<svg class="omr-logo" viewBox="0 0 1024 751" aria-hidden="true" focusable="false"><path d="M 1016 383 L 441 383 L 393 310 L 395 287 L 412 266 L 456 248 L 513 256 L 580 296 L 644 357 L 684 206 L 682 179 L 604 121 L 546 99 L 498 98 L 449 123 L 396 193 L 362 276 L 348 383 L 134 383 L 79 482 L 383 482 L 435 533 L 49 535 L 0 634 L 877 634 L 932 533 L 687 531 L 590 503 L 552 479 L 961 482 Z" fill="currentColor" /></svg>';
  }
  function formatOmanMoney(cents){
    var value=Math.max(0,Number(cents||0))/100;
    var num=value.toFixed(3).replace(/\.000$/,'');
    num=num.replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return '<span class="omr-price" dir="ltr">'+omrSvg()+'<span class="price-num">'+num+'</span></span>';
  }

  if(modal && form){
    var dialog=modal.querySelector('.booking-modal__dialog'),
        steps=[].slice.call(modal.querySelectorAll('[data-booking-step]')),
        tabs=[].slice.call(modal.querySelectorAll('[data-booking-step-tab]')),
        next=modal.querySelector('[data-booking-next]'),
        prev=modal.querySelector('[data-booking-prev]'),
        submit=modal.querySelector('[data-booking-submit]'),
        activeStep=0,
        lastFocus=null;

    function currentVariantInput(){
      return form.querySelector('input[name="id"]:checked') || form.querySelector('[data-variant-id]');
    }
    function selectedBasePrice(){
      var input=currentVariantInput();
      if(input && input.dataset.variantPrice) return Number(input.dataset.variantPrice);
      return Number(form.dataset.basePrice||0);
    }
    function selectedPaymentTitle(){
      var input=currentVariantInput();
      if(input && input.dataset.variantTitle) return input.dataset.variantTitle;
      var label=input && input.closest('.payment-option');
      return label ? label.textContent.trim().replace(/\s+/g,' ') : '';
    }
    function selectedAddons(){
      var items=[],total=0;
      modal.querySelectorAll('[data-addon]').forEach(function(row){
        var qtyInput=row.querySelector('[data-addon-qty]');
        var qty=Number(qtyInput && qtyInput.value || 0);
        if(!qty) return;
        var price=Number(row.dataset.addonPrice||0);
        var name=row.dataset.addonName||(isEnglish?'Add-on':'إضافة');
        items.push({name:name,qty:qty,price:price,total:qty*price});
        total += qty*price;
      });
      return {items:items,total:total};
    }
    function setHTML(sel, html){
      var el=modal.querySelector(sel);
      if(el) el.innerHTML=html;
    }
    function syncRoomVariant(){
      if(form.dataset.roomAddon !== 'true') return;
      var input=currentVariantInput(), row=modal.querySelector('[data-room-supplement]');
      if(!input || !row) return;
      var qty=row.querySelector('[data-addon-qty]');
      var eligible=Boolean(input.dataset.singleId) && input.dataset.singleAvailable==='true' && Number(input.dataset.singlePrice)===Number(input.dataset.variantPrice)+Number(row.dataset.addonPrice);
      var plus=row.querySelector('[data-addon-plus]');
      if(plus) plus.disabled=!eligible;
      if(!eligible && qty) qty.value=0;
      input.value=qty && Number(qty.value)>0 ? input.dataset.singleId : input.dataset.baseId;
      row.classList.toggle('is-selected',Boolean(qty && Number(qty.value)>0));
    }
    function updateSummary(){
      syncRoomVariant();
      var base=selectedBasePrice();
      var addons=selectedAddons();
      var total=base+addons.total;
      var variantInput=currentVariantInput();
      var fullPrice=Number(variantInput && variantInput.dataset.fullPrice || form.dataset.fullPrice || base);
      var remaining=Math.max(0,Math.round((fullPrice-base)*10)/10);
      setHTML('[data-review-full]', formatOmanMoney(fullPrice+(form.dataset.roomAddon==='true' ? addons.total : 0)));
      setHTML('[data-review-remaining]', formatOmanMoney(remaining));
      var dueNote=modal.querySelector('[data-payment-due-note]');
      if(dueNote) dueNote.hidden=remaining<=0;
      var noteProperty=form.querySelector('[data-payment-note-property]');
      if(noteProperty) noteProperty.disabled=remaining<=0;
      var remainingProperty=form.querySelector('[data-remaining-property]');
      if(remainingProperty){remainingProperty.disabled=remaining<=0;remainingProperty.value=(remaining/100).toFixed(3)+' OMR';}
      var names=addons.items.length ? addons.items.map(function(i){return i.name+' × '+i.qty;}).join(isEnglish?', ':'، ') : (isEnglish?'No add-ons':'لا توجد إضافات');
      setHTML('[data-review-base]', formatOmanMoney(base));
      setHTML('[data-review-addons-total]', formatOmanMoney(addons.total));
      setHTML('[data-review-total]', formatOmanMoney(total));
      setHTML('[data-review-addons]', names);
      var addonsProp=form.querySelector('[data-addons-property]');
      var addonsTotalProp=form.querySelector('[data-addons-total-property]');
      var grandTotalProp=form.querySelector('[data-grand-total-property]');
      var paymentProp=form.querySelector('[data-payment-property]');
      var amountConfirmProp=form.querySelector('[data-amount-confirm-property]');
      if(addonsProp) addonsProp.value=names;
      if(addonsTotalProp) addonsTotalProp.value=(addons.total/100).toString();
      if(grandTotalProp) grandTotalProp.value=(total/100).toString();
      if(paymentProp) paymentProp.value=selectedPaymentTitle();
      if(amountConfirmProp) amountConfirmProp.value=(amountConfirm && amountConfirm.checked) ? (amountConfirm.dataset.amountConfirm||(isEnglish?'Amount confirmed':'تم تأكيد المبلغ')) : '';
    }
    function syncRisk(){
      if(!risk || !submit) return;
      var ok=risk.checked;
      submit.disabled=!ok;
      if(riskProp) riskProp.value = ok ? (risk.dataset.confirm||(isEnglish?'Accepted':'تمت الموافقة')) : '';
      submit.textContent = ok ? (submit.dataset.ready||(isEnglish?'Add to cart and continue to payment':'إضافة للسلة ومتابعة الدفع')) : (submit.dataset.idle||(isEnglish?'Accept the acknowledgement first':'وافق على الإقرار أولا'));
    }
    function showStep(index){
      activeStep=Math.max(0,Math.min(steps.length-1,index));
      steps.forEach(function(step,i){ step.classList.toggle('is-active',i===activeStep); });
      tabs.forEach(function(tab,i){ tab.classList.toggle('is-active',i===activeStep); });
      if(prev) prev.hidden=activeStep===0;
      if(next) next.hidden=activeStep===steps.length-1;
      if(submit) submit.hidden=activeStep!==steps.length-1;
      updateSummary();
      syncRisk();
    }
    function canLeaveStep(index){
      if(index===2 && amountConfirm && !amountConfirm.checked){
        amountConfirm.focus();
        var amountRow=amountConfirm.closest('.risk-check');
        if(amountRow){
          amountRow.style.outline='2px solid var(--orange)';
          setTimeout(function(){amountRow.style.outline='';},1600);
        }
        return false;
      }
      if(index!==3) return true;
      var required=[].slice.call(steps[3].querySelectorAll('input[required]'));
      for(var i=0;i<required.length;i++){
        if(!required[i].checkValidity()){
          required[i].reportValidity();
          return false;
        }
      }
      return true;
    }
    function canReachStep(target){
      for(var i=0;i<target;i++){
        if(!canLeaveStep(i)) return false;
      }
      return true;
    }
    function openModal(){
      lastFocus=document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.body.classList.add('booking-modal-open');
      showStep(0);
      setTimeout(function(){ if(dialog) dialog.focus(); },30);
    }
    function closeModal(){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('booking-modal-open');
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.querySelectorAll('[data-booking-open]').forEach(function(btn){
      btn.addEventListener('click',function(e){ e.preventDefault(); openModal(); });
    });
    modal.querySelectorAll('[data-booking-close]').forEach(function(btn){
      btn.addEventListener('click',closeModal);
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && modal.classList.contains('is-open')) closeModal();
    });
    if(next) next.addEventListener('click',function(){
      if(canLeaveStep(activeStep)) showStep(activeStep+1);
    });
    if(prev) prev.addEventListener('click',function(){ showStep(activeStep-1); });
    tabs.forEach(function(tab,i){
      tab.addEventListener('click',function(){
        if(i<=activeStep || canReachStep(i)) showStep(i);
      });
    });
    modal.querySelectorAll('[data-addon]').forEach(function(row){
      var minus=row.querySelector('[data-addon-minus]');
      var plus=row.querySelector('[data-addon-plus]');
      var qty=row.querySelector('[data-addon-qty]');
      var max=Number(qty && qty.max || 9);
      function setQty(value){
        if(!qty) return;
        qty.value=Math.max(0,Math.min(max,Number(value||0)));
        row.classList.toggle('is-selected',Number(qty.value)>0);
        updateSummary();
      }
      if(minus) minus.addEventListener('click',function(){ setQty(Number(qty.value)-1); });
      if(plus) plus.addEventListener('click',function(){ setQty(Number(qty.value)+1); });
    });
    form.querySelectorAll('input[name="id"]').forEach(function(input){
      input.addEventListener('change',updateSummary);
    });
    if(amountConfirm) amountConfirm.addEventListener('change',updateSummary);
    if(risk) risk.addEventListener('change',syncRisk);
    form.addEventListener('submit',updateSummary,true);
    showStep(0);
    if(new URLSearchParams(window.location.search).get('open_booking')==='1' || window.location.hash==='#book'){
      setTimeout(openModal,450);
    }
  }

  /* sticky mobile booking bar visibility */
  var mbar=document.querySelector('.mobile-book');
  if(mbar){
    var anchor=document.querySelector('.facts-bar')||document.querySelector('.tp-hero');
    if(anchor){
      var mio=new IntersectionObserver(function(es){
        es.forEach(function(e){ mbar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top<0); });
      },{threshold:0});
      mio.observe(anchor);
    }
  }
})();


